import Cookies from "js-cookie";
import { decryptData } from "utils/crypto";



export const profileAuditSteps = () => {
  const roleId = Number(decryptData(Cookies.get("role_id")));
  return [
    {
      target: '[data-tour="profile-audit-module"]',
      title: '📊 Profile Audit Logs',
      content:
        'Track all changes made to employee profiles, payroll, and company data.',
      disableBeacon: true,
    },

    {
      target: '[data-tour="profile-audit-myprofile-tab"]',
      title: '👤 My Profile Logs',
      content: 'View audit history of employee profile changes.',
      disableBeacon: true,
    },

    {
      target: '[data-tour="profile-audit-filters"]',
      title: '🔎 Filter Records',
      content:
        'Filter audit logs by date range to find specific changes quickly.',
      disableBeacon: true,
    },

    {
      target: '[data-tour="profile-audit-download-btn"]',
      title: '⬇️ Export Data',
      content:
        'Download audit logs in Excel format for reporting or analysis.',
      disableBeacon: true,
    },

    {
      target: '[data-tour="profile-audit-table"]',
      title: '📋 Audit Table',
      content:
        'View detailed logs including changed fields, old values, and new values.',
      disableBeacon: true,
    },

    // ...(roleId === 1 || roleId === 2
    //   ? [
        {
          target: '[data-tour="profile-audit-payroll-tab"]',
          title: '💰 Payroll Audit',
          content: 'View payroll-related changes made in the system.',
          disableBeacon: true,
        },
        {
          target: '[data-tour="profile-audit-company-tab"]',
          title: '🏢 Company Audit',
          content: 'Track changes made to company-level settings and data.',
          disableBeacon: true,
        },
      // ]
      // : []),
  ];
}